const listItem = Vue.component('list-item', {
    template: `
        <a :href="url" class="article-list-item">
            <div class="article-list-item__image-wrapper">
                <img v-if="imageUrl" class="search__image" :src="decodeURI(imageUrl)" :alt="name" :title="name">
                <img class="search__placeholder-image" v-else src="/resources/img/placeholder.jpg" alt="">
                <button v-if="showButtonIcon" class="heart" :id="id" @click="toggleFavorites" aria-label="Sett som favoritt" v-html="buttonIcon">
                </button>
            </div>
            <h2 class="article-list-item__title">{{ name }}</h2>
        </a>
    `,

    props: [
        'url',
        'id',
        'name',
        'imageUrl',
        'buttonIcon',
        'showButtonIcon'
    ],

    mounted() {
    },

    data() {
        return {
            isActive: false
        };
    },

    methods:{
        toggleFavorites(e){
            this.$emit('toggle-favorites', e);
        }
    },
});

export default listItem;